import CryptoJS from 'crypto-js';

const LOCAL_JWT_KEY = "jskdfls";

export const isStrEmpty = (str) =>{
    if (str == null
        || str == 'undefined'
        || !str || !/[^\s]/.test(str)) {
        return true;
    } else {
        return false;
    }
}

export const isEmptyObject = (obj) =>{
    return obj==null||Object.keys(obj).length == 0;
}

export const setJwtToken = (jwtToken) => {
    sessionStorage.setItem(LOCAL_JWT_KEY,jwtToken)
}
export const getJwtToken = () => {
    return sessionStorage.getItem(LOCAL_JWT_KEY)
}
export const getTokenUser = () => {
    const token = getJwtToken();
    if (!token) return '';
    try {
        let userString = decodeURIComponent(
            window.atob(token.split('.')[1])
        );
        return JSON.parse(userString).sub;
    } catch (e) {
        return '';
    }
}

//浮点数加法运算
export const FloatAdd = function(arg1,arg2){
    let r1,r2,m;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    return (arg1*m+arg2*m)/m;
}

//浮点数减法运算
export const FloatSub = function(arg1,arg2){
    let r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    //动态控制精度长度
    n=(r1=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
}

//浮点数乘法运算
export const FloatMul = function(arg1,arg2)
{
    let m=0, s1=arg1.toString(), s2=arg2.toString();
    try{
        m+=s1.split(".")[1].length
    }catch(e){}
    try{
        m+=s2.split(".")[1].length
    }catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
}


//浮点数除法运算
export const FloatDiv = function(arg1,arg2){
    let t1=0,t2=0,r1,r2;
    try{t1=arg1.toString().split(".")[1].length}catch(e){}
    try{t2=arg2.toString().split(".")[1].length}catch(e){}
    r1=Number(arg1.toString().replace(".",""));
    r2=Number(arg2.toString().replace(".",""));
    return (r1/r2)*Math.pow(10,t2-t1);
}

export const replaceString = function (str, indexAry, char) {
    const strAry = str.split('');
    for (let i = 0; i < strAry.length; i++){
        if (indexAry.includes(i+"")){
            continue;
        }
        strAry[i] = char;
    }
    return strAry.join('').toString();
}

export const validatePhone = function(value,callback) {
    const reg =/^[1][3-9][0-9]{9}$/;
    if(value==''||value==undefined||value==null){
        callback(false);
    }else {
        if ((!reg.test(value)) && value != '') {
            callback(false);
        } else {
            callback(true);
        }
    }
}

export const encryptPassword = (password) =>{
    let keyStr = "CXMGNcYwTrtsadQmV935ONNXMUycpG1g"; //判断是否存在ksy，不存在就用定义好的key
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let srcs = CryptoJS.enc.Utf8.parse(password);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

export const decryptPassword = (password) => {
    let keyStr = "CXMGNcYwTrtsadQmV935ONNXMUycpG1g"; //判断是否存在ksy，不存在就用定义好的key
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let decrypt = CryptoJS.AES.decrypt(password, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}


export const filterArrObj = (arr,filterField) =>{
    let newArr = arr.reduce((pre,cur) => pre.some(item => item[filterField] == cur[filterField]) ?
        pre : [...pre,cur],[])
    return newArr
}

export const checkWebsite = async (url) => {
    try {
        const response = await fetch(url, {
            headers:{
         'content-type':'application/json'
     }, 
     method: 'HEAD' });
        return response.ok;
    } catch (error) {
        return false;
    }
}

export const guid = () => {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}


//新增对客服支持的工具函数
export const wss = (wsSocketUrl) => {
    let isHttps = document.location.protocol === 'https:';
    let wsProtocol = isHttps ? 'wss:' : 'ws:';
    return wsSocketUrl.replace(/^ws:|^wss:/, wsProtocol);
}

export const setLoc = (k, v) => {
    if (typeof v === 'string') {
        localStorage.setItem(k, v);
    }
    localStorage.setItem(k, JSON.stringify(v));

    return v;
}

export const getLoc = (k) => {
    let v = localStorage.getItem(k);
    try {
        if (typeof v != 'number') {
            v = JSON.parse(v);
        }
    } catch (e) {
    }
    return v;
}

export function getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}